import React from 'react'
import { Row, Tabs, Spin } from 'antd'
import Overview from './Overview/overview'
import S3 from './S3/s3'
import StorageUsage from './StorageUsage/storage-usage'
import EC2 from './EC2/ec2'
import DataTransfer from './DataTransfer/data-transfer'
import RDS from './RDS/rds'
import EFS from './EFS/efs'
import EFSUsage from './EFSUsage/efs-usage'
import CloudWatch from './CloudWatch/cloud-watch'
import DirectConnect from './DirectConnect/direct-connect'
import Support from './Support/support'
import Route53 from './Route53/route53'
import DownloadInvoice from './DownloadInvoice/index'
import BucketCost from './BucketCost/bucket-cost'
import DatabaseCost from './DatabaseCost/database-cost'

const TabPane = Tabs.TabPane;
function callback(key) {
    //console.log(key);
}
const storageUsageData = (selectedAccount) => {
    const storageList = []

    if(selectedAccount != undefined)
    {
        selectedAccount && selectedAccount.storages && selectedAccount.storages.map( (st) => {
            storageList.push([ st.bucket_name , st.size])
        })

    }
    return storageList

}


const product_cost = (productsTotalCost, productCode) =>
{
    let productCost = 0
    productsTotalCost.map((product) => {
        if(product.product_code == productCode)
            productCost =  product.total_cost
            })
    return productCost
}

export default ({   productsTotalCost,
                    handleCloudAccountChange,
                    selectedAccount,
                    selectedMonth,
                    chartsData,
                    cloudAccounts,
                    servicesData,
                    on_download,
                    on_bucket_change,
                    on_bucket_usage_type_change,
                    on_clear_filter_bucket_cost,
                    on_database_change,
                    on_database_usage_type_change,
                    on_clear_filter_database_cost
                }) => (
    <div>
        <Row>
            <Tabs defaultActiveKey="1" onChange={callback}>
                <TabPane tab="Overview" key="1">
                    {
                        (chartsData.overviewLoading) ?
                        (<Spin size='large' tip='Loading...' style={{ padding: '15% 50%', margin: '0 auto' }} />) :
                        (<Overview selectedAccount={selectedAccount} selectedMonth={selectedMonth} overviewChartData={ chartsData.overviewChartData } servicesData={ servicesData } productsTotalCost={productsTotalCost} />)
                    }
                </TabPane>
                <TabPane tab="S3" key="2">
                    {
                        (chartsData.s3Loading) ?
                        (<Spin size='large' tip='Loading...' style={{ padding: '15% 50%', margin: '0 auto' }} />) :
                        (<S3 selectedAccount={selectedAccount}
                            s3ChartData={chartsData.s3ChartData}
                            totalCost={productsTotalCost && product_cost(productsTotalCost,'AmazonS3')} />)
                    }
                </TabPane>
                <TabPane tab="Bucket Cost" key="3">
                    {
                        (chartsData.bucketCostLoading) ?
                        (<Spin size='large' tip='Loading...' style={{ padding: '15% 50%', margin: '0 auto' }} />) :
                        (<BucketCost selectedAccount={selectedAccount}
                                bucketCostData={chartsData.bucketCostData}
                                on_bucket_change={on_bucket_change}
                                on_bucket_usage_type_change={on_bucket_usage_type_change}
                                on_clear_filter_bucket_cost={on_clear_filter_bucket_cost}/>)
                    }
                </TabPane>
                <TabPane tab="Storage Usage" key="4">
                    <StorageUsage selectedAccount={selectedAccount}
                            storageUsageChartData={storageUsageData(selectedAccount)}
                            totalCost={productsTotalCost && product_cost(productsTotalCost,'AmazonS3')}/>
                </TabPane>
                <TabPane tab="EC2" key="5">
                    {
                        (chartsData.ec2Loading) ?
                        (<Spin size='large' tip='Loading...' style={{ padding: '15% 50%', margin: '0 auto' }} />) :
                        (<EC2 selectedAccount={selectedAccount} ec2ChartData={chartsData.ec2ChartData}
                            totalCost={productsTotalCost && product_cost(productsTotalCost,'AmazonEC2')}/>)
                    }
                </TabPane>
                <TabPane tab="Data Transfer" key="6">
                    {
                        (chartsData.dataTransferLoading) ?
                        (<Spin size='large' tip='Loading...' style={{ padding: '15% 50%', margin: '0 auto' }} />) :
                        (<DataTransfer selectedAccount={selectedAccount} dataTransferChartData={chartsData.dataTransferChartData}
                        totalCost={productsTotalCost && product_cost(productsTotalCost,'AWSDataTransfer')}/>)
                    }
                </TabPane>
                <TabPane tab="Amazon RDS" key="7">
                    {
                        (chartsData.rdsLoading) ?
                        (<Spin size='large' tip='Loading...' style={{ padding: '15% 50%', margin: '0 auto' }} />) :
                        (<RDS selectedAccount={selectedAccount} rdsChartData={chartsData.rdsChartData}
                            totalCost={productsTotalCost && product_cost(productsTotalCost,'AmazonRDS')}/>)
                    }
                </TabPane>
                <TabPane tab="Database Cost" key="8">
                    {
                        (chartsData.databaseCostLoading) ?
                        (<Spin size='large' tip='Loading...' style={{ padding: '15% 50%', margin: '0 auto' }} />) :
                        (<DatabaseCost selectedAccount={selectedAccount}
                                databaseCostData={chartsData.databaseCostData}
                                on_database_change={on_database_change}
                                on_database_usage_type_change={on_database_usage_type_change}
                                on_clear_filter_database_cost={on_clear_filter_database_cost}/>)
                    }
                </TabPane>
                <TabPane tab="Cloud Watch" key="9">
                    {
                        (chartsData.cloudWatchLoading) ?
                        (<Spin size='large' tip='Loading...' style={{ padding: '15% 50%', margin: '0 auto' }} />) :
                        (<CloudWatch selectedAccount={selectedAccount} cloudWatchChartData={chartsData.cloudWatchChartData}
                            totalCost={productsTotalCost && product_cost(productsTotalCost,'AmazonCloudWatch')}/>)
                    }
                </TabPane>
                <TabPane tab="EFS Cost" key="10">
                    {
                        (chartsData.efsLoading) ?
                        (<Spin size='large' tip='Loading...' style={{ padding: '15% 50%', margin: '0 auto' }} />) :
                        (<EFS selectedAccount={selectedAccount} efsChartData={chartsData.efsChartData}
                            totalCost={productsTotalCost && product_cost(productsTotalCost,'AmazonEFS')}/>)
                    }
                </TabPane>
                <TabPane tab="EFS Usage" key="11">
                    {
                        (chartsData.efsUsageLoading) ?
                        (<Spin size='large' tip='Loading...' style={{ padding: '15% 50%', margin: '0 auto' }} />) :
                        (<EFSUsage selectedAccount={selectedAccount} efsChartData={chartsData.efsChartData}
                            efsUsageData={chartsData.efsUsageData}
                            totalCost={productsTotalCost && product_cost(productsTotalCost,'AmazonEFS')}/>)
                    }
                </TabPane>
                <TabPane tab="Direct Connect" key="12">
                    {
                        (chartsData.directConnectLoading) ?
                        (<Spin size='large' tip='Loading...' style={{ padding: '15% 50%', margin: '0 auto' }} />) :
                        (<DirectConnect selectedAccount={selectedAccount} directConnectChartData={chartsData.directConnectChartData}
                            totalCost={productsTotalCost && product_cost(productsTotalCost,'AWSDirectConnect')}/>)
                    }
                </TabPane>
                {productsTotalCost.map((product) => {
                    if(product.product_code == 'AWSSupport')
                    return (<TabPane tab="AWS Support" key="13">
                                {
                                    (chartsData.supportLoading) ?
                                    (<Spin size='large' tip='Loading...' style={{ padding: '15% 50%', margin: '0 auto' }} />) :
                                    (<Support selectedAccount={selectedAccount} supportChartData={chartsData.supportChartData}
                                        totalCost={productsTotalCost && product_cost(productsTotalCost,'AWSSupport')}/>)
                                }
                            </TabPane>)
                })}
                <TabPane tab="Route 53" key="14">
                    {
                        (chartsData.route53Loading) ?
                        (<Spin size='large' tip='Loading...' style={{ padding: '15% 50%', margin: '0 auto' }} />) :
                        (<Route53 selectedAccount={selectedAccount} route53ChartData={chartsData.route53ChartData}
                            totalCost={productsTotalCost && product_cost(productsTotalCost,'AmazonRoute53')}/>)
                    }
                </TabPane>

                <TabPane tab="Download Invoice" key="15">
                    {
                        (chartsData.downloadInvoice.loading) ?
                        (<Spin size='large' tip='Loading...' style={{ padding: '15% 50%', margin: '0 auto' }} />) :
                        (<DownloadInvoice selectedAccount={selectedAccount} downloadInvoiceData={chartsData.downloadInvoice.billingBucketData} on_download={on_download} />)
                    }
                </TabPane>
                
            </Tabs>
        </Row>
    </div>
)
